<template>

  <main class="main">
  	<div class="contact_banner">
		<div>
			<div class="w1200">
				<h1>创酷天下：给客户带来价值</h1>
	            <h5>公司在飞速发展，服务的客户与日俱增，但无论走得多远，<br>我们都将本着给客户带来价值的价值观，服务好每一个客户，与您一同乘帆远航。</h5>
			</div>
			<img class="pic2" src="../assets/price/banner_river.png">
		</div>
	</div>
	<div class="w1200 mobile">
		<div class="el_tab_div">
			<h1 class="title"><img src="#">创酷天下</h1>
			<div class="line"></div>
			<div style="font-size: 16px;color:#666;margin-top:30px;">
				我们致力于“城市后勤公共服务中心”的建设及运营工作，以中心为载体向各级企事业单位提供“后勤云管家”服务。云管家服务是将“数字化制度、数字化智能平台、数字化管理师”进行有机融合，形成以结果为导向的一站式管理服务。 从根本上解决客户后勤管理中“管什么、怎么管、谁来管”的三大难点。不仅帮助各级企事业单位实现后勤管理智能化升级，解决相关具体问题，同时也为智慧城市、智慧行业的建设夯实基础。
			</div>
			<h1 class="title"><img src="#">企业文化</h1>
			<div class="line"></div>
			<el-row class="our" :gutter="10">
				<el-col :span="8">
					<em></em>
					我们的愿景<br>云资产覆盖每件资产
				</el-col>
				<el-col :span="8">
					<em></em>
					我们的使命<br>守护天下资产
				</el-col>

				<el-col :span="8">
					<em></em>
					我们的价值观<br>给客户带来价值
				</el-col>
			</el-row>
		</div>
	</div>
	<div class="w1000 pc" style="margin-bottom: 100px;">
		<el-tabs v-model="activeName" @tab-click="handleClick">
	    <el-tab-pane label="公司介绍" name="1">
	    	<div class="el_tab_div">
	    		<h1 class="title"><img src="#">创酷天下</h1>
  				<div class="line"></div>
	    		<div style="font-size: 16px;color:#666;margin-top:30px;">
	    			我们致力于“城市后勤公共服务中心”的建设及运营工作，以中心为载体向各级企事业单位提供“后勤云管家”服务。云管家服务是将“数字化制度、数字化智能平台、数字化管理师”进行有机融合，形成以结果为导向的一站式管理服务。 从根本上解决客户后勤管理中“管什么、怎么管、谁来管”的三大难点。不仅帮助各级企事业单位实现后勤管理智能化升级，解决相关具体问题，同时也为智慧城市、智慧行业的建设夯实基础。 从根本上解决客户后勤管理中“管什么、怎么管、谁来管”的三大难点。不仅帮助各级企事业单位实现后勤管理智能化升级，解决相关具体问题，同时也为智慧城市、智慧行业的建设夯实基础。
	    		</div>
	    		<h1 class="title"><img src="#">企业文化</h1>
  				<div class="line"></div>
  				<el-row class="our" :gutter="100">
	    			<el-col :span="8">
	    				<em></em>
	    				我们的愿景<br>云资产覆盖每件资产
	    			</el-col>
	    			<el-col :span="8">
	    				<em></em>
	    				我们的使命<br>守护天下资产
	    			</el-col>

	    			<el-col :span="8">
	    				<em></em>
	    				我们的价值观<br>给客户带来价值
	    			</el-col>
    			</el-row>
  				
  				<el-carousel :interval="100000" height="300px" arrow="always" type="card">
					  <el-carousel-item>
				    	<div class="product-img">
					  		<div>
					  			  <img src="../assets/product/school_sz.jpg" title="" alt="">
					  		</div>
					  	</div>
				     
				    </el-carousel-item>
				    <el-carousel-item>
					    <div class="product-img">
					  		<div>
					  			 <img src="../assets/product/school_bq.jpg" title="" alt="">
					  		</div>
					  	</div>
				     
				    </el-carousel-item>
				    <el-carousel-item>
				    	<div class="product-img">
					  		<div>
					  			 <img src="../assets/product/school_sd.jpg" title="" alt="">
					  		</div>
					  	</div>
				      
				    </el-carousel-item>
				    
				</el-carousel>
	    	</div>
	    </el-tab-pane>
	    <el-tab-pane label="加入我们" name="2">
	    	<h1 class="title"><img src="#">现招职位</h1>
			<div class="line"></div>
			<h5 style="color:#999;text-align: center;">投递邮箱 wj@weijin365.com</h5>
	    	<div class="el_tab_div">
	    		<el-tabs :tab-position="tabPosition" style="margin:50px 0;">
				    <el-tab-pane label="社会招聘">
				    	<ul class="post_cards">
				    		<li>
				    			<em class="el-icon-s-tools"></em>
				    			<b>实施团队</b>
				    			
				    			<el-popover placement="right"  width="400" trigger="click" class="right">
				    				<div>
										岗位职责：<br>
										1.独立完成公司ERP等信息化项目的实施应用和管理维护工作；<br>
										2.内部ERP实施顾问和相关问题的解决；<br>
										3.负责公司内部计算机及网络应用知识培训；<br>
										4.完成上级领导安排的工作任务。<br>
										任职要求：<br>
										1、计算机或计算机软件专业；<br>
										2、具备一定的MSSQLserver数据库的操作和维护知识和维护能力；<br>
										3、有ERP软件产品实施经验者优先考虑，有用友实施经验者更佳；<br>
				    				</div>
								  <el-button slot="reference"><i class="el-icon-arrow-right"></i></el-button>
								</el-popover>
								<i class="el-icon-location right">苏州</i>
							</li>
							<li>
				    			<em class="el-icon-s-custom"></em>
				    			<b>电话营销</b>
				    			
				    			<el-popover placement="right"  width="400" trigger="click" class="right">
				    				<div>
				    					【岗位职责】：<br>

										1.负责公司产品城区内的市场推广和渠道销售；<br>

										2.负责城区内代理商的开发、沟通、跟进、签约；<br>

										3.负责城区内渠道销售活动的安排和执行；<br>

										4.负责渠道销售计划按时完成，跟进售后服务及合同收入回款；<br>

										5.通过电话、微信、拜访等方式与渠道商建立长期良好的合作关系，进行渠道关系管理。<br>

										【任职要求】：<br>

										１.大专及以上相关学历，计算机、市场营销相关专业优先；<br>

										２.具有较强的学习能力，积极主动，抗压能力强；<br>

										３.具有较强的沟通协调能力和人际关系管理能力；<br>

										４.吃苦耐劳，诚实守信，待时守分，赤诚相待。<br><br>

				    				</div>
								  <el-button slot="reference"><i class="el-icon-arrow-right"></i></el-button>
								</el-popover>
								<i class="el-icon-location right">苏州</i>
							</li>
				    		<li>
				    			<em class="el-icon-s-marketing"></em>
				    			<b>销售团队</b>
				    			<el-popover placement="right"  width="400" trigger="click" class="right">
					    			<div>
					    				职位描述: 岗位职责：<br>

											【岗位职责】：<br>

										1.负责公司产品城区内的市场推广和渠道销售；<br>

										2.负责城区内代理商的开发、沟通、跟进、签约；<br>

										3.负责城区内渠道销售活动的安排和执行；<br>

										4.负责渠道销售计划按时完成，跟进售后服务及合同收入回款；<br>

										5.通过电话、微信、拜访等方式与渠道商建立长期良好的合作关系，进行渠道关系管理。<br>

										【任职要求】：<br>

										１.大专及以上相关学历，计算机、市场营销相关专业优先；<br>

										２.具有较强的学习能力，积极主动，抗压能力强；<br>

										３.具有较强的沟通协调能力和人际关系管理能力；<br>

										４.吃苦耐劳，诚实守信，待时守分，赤诚相待。<br><br><br>
					    			</div>
								  <el-button slot="reference"><i class="el-icon-arrow-right"></i></el-button>
								</el-popover>
								<i class="el-icon-location right">苏州</i>
							</li>
				    	</ul>
				    </el-tab-pane>
				    <el-tab-pane label="校园招聘">
				    	<ul class="post_cards">
				    		<li>
				    			<em class="el-icon-s-tools"></em>
				    			<b>实施团队</b>
				    			
				    			<el-popover placement="right"  width="400" trigger="click" class="right">
				    				<div>
										岗位职责：<br>
										1.独立完成公司ERP等信息化项目的实施应用和管理维护工作；<br>
										2.内部ERP实施顾问和相关问题的解决；<br>
										3.负责公司内部计算机及网络应用知识培训；<br>
										4.完成上级领导安排的工作任务。<br>
										任职要求：<br>
										1、计算机或计算机软件专业；<br>
										2、具备一定的MSSQLserver数据库的操作和维护知识和维护能力；<br>
										3、有ERP软件产品实施经验者优先考虑，有用友实施经验者更佳；<br>
				    				</div>
								  <el-button slot="reference"><i class="el-icon-arrow-right"></i></el-button>
								</el-popover>
								<i class="el-icon-location right">苏州</i>
							</li>
				    	</ul>
				    </el-tab-pane>
				    <el-tab-pane label="实习生招聘">
				    	<ul class="post_cards">
				    		<li>
				    			<em class="el-icon-s-marketing"></em>
				    			<b>销售团队</b>
				    			<el-popover placement="right"  width="400" trigger="click" class="right">
				    				<div>
					    				职位描述: 岗位职责：<br>

											【岗位职责】：<br>

										1.负责公司产品城区内的市场推广和渠道销售；<br>

										2.负责城区内代理商的开发、沟通、跟进、签约；<br>

										3.负责城区内渠道销售活动的安排和执行；<br>

										4.负责渠道销售计划按时完成，跟进售后服务及合同收入回款；<br>

										5.通过电话、微信、拜访等方式与渠道商建立长期良好的合作关系，进行渠道关系管理。<br>

										【任职要求】：<br>

										１.大专及以上相关学历，计算机、市场营销相关专业优先；<br>

										２.具有较强的学习能力，积极主动，抗压能力强；<br>

										３.具有较强的沟通协调能力和人际关系管理能力；<br>

										４.吃苦耐劳，诚实守信，待时守分，赤诚相待。<br><br><br>
					    			</div>
								  <el-button slot="reference"><i class="el-icon-arrow-right"></i></el-button>
								</el-popover>
								<i class="el-icon-location right">苏州</i>
							</li>
				    	</ul>
				    </el-tab-pane>
				  </el-tabs>
	    	</div>
	    </el-tab-pane>
	    <el-tab-pane label="代理商渠道" name="3">
	    	<h1 class="title"><img src="#">招商咨询</h1>
			<div class="line"></div>
			<h5 style="color:#999;text-align: center;">咨询电话 15962434800</h5>
	    	<div class="el_tab_div">
	    		
	    	</div>
	    </el-tab-pane>
	    <el-tab-pane label="联系我们" name="4">
	    	<h1 class="title"><img src="#">联系我们</h1>
			<div class="line"></div>
			<h5 style="color:#999;text-align: center;">有任何问题可随时和我们联系哦，我们的售后24小时为您服务。</h5>
	    	<div class="el_tab_div">
	    		<el-row class="company_detail":gutter="100">
	    			<el-col :span="12">
	    				<ol>
		    				<li>
		    					<em class="el-icon-discount"></em>
		    					<b>公司：</b>
		    					<span>苏州创酷天下网络科技有限公司</span>
		    				</li>
		    				<li>
		    					<em class="el-icon-map-location"></em>
		    					<b>地址：</b>
		    					<span>江苏省苏州市相城区活力大厦A幢19层1903号</span>
		    				</li>
		    				<li>
		    					<em class="el-icon-phone-outline"></em>
		    					<b>电话：</b>
		    					<span>15962434800</span>
		    				</li>
		    				<li>
		    					<em class="el-icon-message"></em>
		    					<b>邮箱：</b>
		    					<span>wj@weijin365.com</span>
		    				</li>
		    			</ol>
	    			</el-col>
	    			<el-col :span="12">
	    				<img src="../assets/map.jpg" style="margin:30px 0;width:75%;">
	    			</el-col>
    			</el-row>
    			
	    	</div>
	    </el-tab-pane>
	  </el-tabs>
	</div>
  </main>
</template>
<script>
export default {
  name: 'contact',
  data () {
    return {
        activeName: '1',
        tabPosition:'left',
      }
  },
  watch: {
	  '$route' (to, from) { 
		  if(to.query.type != from.query.type){
			  this.activeName=String(this.$route.query.type)
		  }
	  }
  },
  created(){
  	this.activeName=String(this.$route.query.type)
  },
  methods: {
      handleClick(tab, event) {

      }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/contact.vue